import React from 'react';
import PropTypes from 'prop-types';
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import classnames from 'classnames';

/**
 * A wrapper for react-draft-wysiwyg rich text editor which outputs editor content as HTML via an onChange handler
 */

class TextEditorBase extends React.Component {
  constructor(props) {
    super(props);
    let editorState;
    if (props.initialValue && props.initialValue !== '<p></p>\n') {
      editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(props.initialValue))
      );
    } else {
      editorState = EditorState.createEmpty();
    }
    this.state = {
      editorState,
      editorFocus: false,
    };
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }

  onEditorStateChange = editorState => {
    const { onChange } = this.props;
    this.setState({
      editorState,
    });
    if (onChange) {
      onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }
  };

  onEditorFocusChange = editorFocus => {
    const { onBlur } = this.props;
    this.setState({
      editorFocus,
    });
    if (!editorFocus && onBlur) onBlur();
  };

  render() {
    const { editorState, editorFocus } = this.state;
    const { invalid, valid, toolbarOptions } = this.props;
    return (
      <Editor
        editorState={editorState}
        wrapperClassName={classnames(
          'text-editor-container',
          invalid ? 'is-invalid' : '',
          valid ? 'is-valid' : '',
          'form-control',
          editorFocus ? 'focus' : ''
        )}
        toolbarClassName="text-editor-toolbar"
        editorClassName="text-editor-area"
        onEditorStateChange={this.onEditorStateChange}
        onFocus={() => this.onEditorFocusChange(true)}
        onBlur={() => this.onEditorFocusChange(false)}
        toolbar={toolbarOptions}
        handlePastedText={() => false}
      />
    );
  }
}

TextEditorBase.propTypes = {
  /** HTML to populate editor on first render */
  initialValue: PropTypes.node,
  /** For UI feedback */
  invalid: PropTypes.bool,
  /** on Editor state change handler */
  onChange: PropTypes.func.isRequired,
  /** handler for Editor onBlur event */
  onBlur: PropTypes.func,
  /** Toolbar options
      [See this comment for toolbar options.](https://github.com/jpuri/react-draft-wysiwyg/issues/4#issuecomment-256276114)
  */
  toolbarOptions: PropTypes.shape({}),
  /** For UI feedback */
  valid: PropTypes.bool,
};

TextEditorBase.defaultProps = {
  initialValue: null,
  invalid: false,
  onBlur: () => {},
  toolbarOptions: null,
  valid: false,
};

export default TextEditorBase;
